import React, { useContext, useEffect } from "react";
import { RouteContext } from "../../outboundAmzl/context/RouteContextProvider";
import { OutboundFilterContext } from "../../outboundAmzl/context/OutboundFilterContext";
import { OutboundConfigContext } from "../../outboundAmzl/context/OutboundConfigContext";
import {
  getBaseUrl,
  parseCapabilitiesResponse,
} from "../../outboundAmzl/util/Util";
import { CapabilityContext } from "../../overview/context/CapabilityContext";
import { getRefreshInterval } from "../../overview/utils/utils";
import {
  ADDITIONAL_METRICS_VIEW,
  TABULAR_GRID_VIEW,
  VISUAL_GRID_VIEW,
} from "../../outboundAmzl/util/Constants";
import {
  getCycleDataFromParent,
  getDocumentURL,
  getNodeCapability,
} from "../../handler/ParentDataHandler";

import TabularGridViewARV2 from "./TabularGridViewARV2";
import VisualGridViewARV2 from "./VisualGridViewARV2";
import Row from "@amzn/meridian/row";
import FPHView from "../../FPH/FPHView";
import ComplianceView from "../../complaince/complianceView";
import OverallStatusView from "../../overallstatus/OverallStatusView";
import { CycleFilterContext } from "../../overview/context/CycleFilterContext";

const RouteGridViewARV2 = () => {
  const { viewModel, dispatch } = useContext(RouteContext);
  const { viewModelF, dispatchF } = useContext(OutboundFilterContext);
  const { outboundConfigModel } = useContext(OutboundConfigContext);
  const { dispatch: configDispatch } = useContext(CapabilityContext);
  const { dispatch: cycleDispatch } = useContext(CycleFilterContext);

  let routeList = viewModel.routeList;

  const filterDeparture = (route) => {
    if (viewModelF.departure.length === 0) {
      return true;
    }
    let result = false;
    viewModelF.departure.forEach((departure) => {
      if (route.routeSLA.includes(departure)) {
        result = true;
      }
    });
    return result;
  };

  routeList = routeList.filter((route) => filterDeparture(route));

  const getRouteData = () => {
    // NOTE: getNodeCapability here sets capability like AR_NEXT_GEN
    Promise.all([getDocumentURL(), getNodeCapability()]).then((result) => {
      //const result = ["https://logistics.amazon.co.jp", {capability: "\"" + CORE_AMZL + "\""}];
      dispatch({
        type: "LOAD_VIEW",
        data: {
          dispatcher: dispatch,
          filterDispatcher: dispatchF,
          baseUrl: getBaseUrl(result[0]),
          capability: parseCapabilitiesResponse(result[1]),
          stationConfig: outboundConfigModel.stationConfig,
        },
      });
      configDispatch({ type: "GET_CAPABILITIES", capabilities: result[1] });
    });
  };

  /**
   * This gets invoked on following events:
   *  1. On every page load
   */
  useEffect(() => {
    getRouteData();
    getCycleDataFromParent().then((cycleData) => {
      cycleDispatch({ type: "INITIALIZE_CYCLES", cycleData });
    });
    let firstPollTime = getRefreshInterval();
    const timeoutHandler = () => {
      getRouteData();
      timeout = setTimeout(timeoutHandler, getRefreshInterval());
    };
    let timeout = setTimeout(timeoutHandler, firstPollTime);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div>
      {viewModelF.waveViewType === VISUAL_GRID_VIEW && (
        <VisualGridViewARV2 routeList={routeList} />
      )}
      {viewModelF.waveViewType === TABULAR_GRID_VIEW && (
        <TabularGridViewARV2 routeList={routeList} />
      )}
      {viewModelF.waveViewType === ADDITIONAL_METRICS_VIEW && (
        <div>
          <Row widths={["grid-3", "grid-3", "grid-3"]} spacingInset="large">
            <FPHView
              fph={{ processName: "pick", refreshRate: getRefreshInterval() }}
            />
            <FPHView
              fph={{ processName: "sort", refreshRate: getRefreshInterval() }}
            />
            <FPHView
              fph={{ processName: "stage", refreshRate: getRefreshInterval() }}
            />
          </Row>
          <Row widths={["grid-3"]} spacingInset="none large">
            <ComplianceView
              compliance={{
                processName: "scanCompliance",
                refreshRate: getRefreshInterval(),
              }}
            />
          </Row>
          <OverallStatusView />
        </div>
      )}
    </div>
  );
};

export default RouteGridViewARV2;



// WEBPACK FOOTER //
// ./src/components/outboundARv2/routegridview/RouteGridViewARV2.js